import { message, Skeleton } from 'antd';
import React, { useEffect } from 'react';
import stringifyAny from 'services/hitchit/types/shared/stringifyAny';

export function useQueryResult({ error, data }: { error?: Error | unknown; data: unknown }): {
  componentToRender: JSX.Element | undefined;
} {
  useEffect(() => {
    if (error) {
      message.error(
        // if error has message key, use that, otherwise use error.toString()
        (error as Error).message || stringifyAny(error)
      );
    }
  }, [error]);

  return {
    componentToRender: !error && !data ? <Skeleton /> : undefined,
  };
}
